import axios from 'axios';

import { getAvailabilities } from '../mapper/mapToAvailabilities';
import { type Availability, type AvailabilityRaw } from '../types/availability';

async function handleGetAvailabilities({
    productId,
    experienceId,
}: {
    productId: string;
    experienceId: string;
}): Promise<Availability[]> {
    const response = await axios.get<AvailabilityRaw[]>(
        `/api/availabilities/${productId}/${experienceId}`,
    );
    if (response.status !== 200) {
        throw new Error('Failed to fetch availabilities');
    }

    return getAvailabilities(response.data);
}

export { handleGetAvailabilities };
